export default "__VITE_ASSET__odb0Mt6j__"